<template>
  <div class="academicLiteratureList">
    <div class="academicLiteratureList-container">
      <div class="academicLiteratureList-tab">
        <Tabs 
          v-model="active" 
          swipeable
          @change="fetchData()"
          background="#FF8E2E" 
          color="#FFFFFF" 
          title-inactive-color="#FFFFFF" 
          title-active-color="#FFFFFF"
          :line-width="22" 
          :style="{height:'100%'}">
          <Tab v-for="tab in tabList" :key="tab.key" :style="{height:'100%'}" :title="tab.name"></Tab>
          <!-- 头部筛选 -->
            <DropdownMenu active-color="#FE7922" :style="{height:'40px'}">
              <CDropDownItem  title="研究类型" :title-class="article_type__in.length ? 'drop-down-item-title drop-down-item-title-active' : 'drop-down-item-title'" @change='fetchData()' v-model="article_type__in" :options="parentTabSelect.researchType"  multiple/>
              <CDropDownItem  title="病例数据" :title-class="case_concluded__in.length ? 'drop-down-item-title drop-down-item-title-active' : 'drop-down-item-title'" @change='fetchData()' v-model="case_concluded__in" :options="parentTabSelect.casesData" multiple />
              <CDropDownItem  title="期刊分类" :title-class="journal_type__in.length ? 'drop-down-item-title drop-down-item-title-active' : 'drop-down-item-title'" @change='fetchData()' v-model="journal_type__in" :options="parentTabSelect.journalData" multiple v-if="active === 0 ? true : false" />
              <CDropDownItem  title="治疗方案" :title-class="treatmentMethod.length ? 'drop-down-item-title drop-down-item-title-active' : 'drop-down-item-title'" @change='fetchData()' v-model="treatmentMethod" :options="parentTabSelect.treatmentMethod" multiple />           
            </DropdownMenu>
            <!-- 更新时间 -->
            <UpdateTime :total='response.count || 0' :updateTime='response.last_add_time' />
            <List ref="list" :length='(response.results || []).length' :total='response.count || 0' @scroll="handlerScroll" :top="118" @refresh='handleRefresh(10)' :isRefresh='refresh' :isScroll='isScroll'>
              <SimpleCard v-for="(item,itemIndex) in response.results || []" :key="item.id" style="border-bottom:1px solid #F1EFF2;" @click='handleCardClick(item,itemIndex)' :ref="`simpleCard-${item.id}`" :id="`simpleCard-${item.id}`">
                <div>{{itemIndex + 1}}. {{item.title}}</div>
                <div slot="footer" class="footer">
                    <div class="footer-top van-ellipsis">
                      <div class="van-ellipsis"  v-show="item.journal_name" style="max-width:1.8rem;margin-right:8px">《{{item.journal_name}}》</div>
                      <div class="van-ellipsis" v-show="item.first_author" style="margin-right:8px;min-width:0.5rem;">{{item.first_author}}</div>
                      <div  style="min-width:0.8rem;" v-show="item.publish_date">{{item.publish_date}}</div>
                    </div>
                    <div class="footer-tag">
                      <Tag  v-for="tag in item.tag_list" :color='tag[3]'  :key="tag[0]" :style="{'color':tag[2]}" style="margin-right:8px;margin-bottom:0.08rem;" >{{tag[0]}}</Tag>
                    </div>
                </div>
              </SimpleCard>
            </List>
        </Tabs>
      </div>
     
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { random } from 'utils/baseMethods'
import { HttpRequest} from 'utils/'
import CDropDownItem from 'components/dropdown-item'
import { Toast } from 'vant'
import { debounce } from 'utils/baseMethods'
export default {
  name:'AcademicLiteratureList',
  data() {
    return {
      active:0,
      tabList:[
        {
          name:'全部',
          key:'0'
        },
        {
          name:'中文',
          key:'1'
        },
        {
          name:'英文',
          key:'2'
        }
      ],
      isScroll:false,
      random:random,
      article_type__in:[],
      case_concluded__in:[],
      journal_type__in:[],
      treatmentMethod:[],
      pageSize:10,
      color:[
        "#FF5D5D",
        "#FF8E2E",
        "#0D9EE0",
        "#826DFF",
      ],
      bgColor:[
        'rgba(255,93,93,0.16)',
        'rgba(255,142,46,0.16)',
        'rgba(13,158,224,0.16)',
        'rgba(130,109,255,0.16)',
      ],
      scrollTop:0,
      response:{},
      timeOut:null,
      refresh:false,
    }
  },
  components:{
    CDropDownItem
  },
  computed:{
    ...mapState({
      tabSelect:state => state.tabSelect
    }),
    parentTabSelect(){
    let article_type = []
    try {
      article_type = this.tabSelect.tabSelect.journal.article_type
    }catch(e){
      article_type = []
    }
    let data =  {
        researchType:article_type.map(obj=>{
            return {
              text:obj.name,
              value:obj.name
            }
          }).filter(obj=>obj.text),
        casesData:[
          { text: "有病例数据",value: "Y"},
          { text: "无病例数据",value: "N"}
        ],
        journalData:[
          { text: "SCI",value: "SCI"},
          { text: "核心期刊",value: "核心期刊"}
        ],
        treatmentMethod:[
            { text: '支持治疗',value:'supportive_care'},
            { text: '联合疗法',value:'combination_therapy'},
            { text: '抗生素',value:'antibiotics'},
            { text: '奥司他韦',value:'oseltamivir'},
            { text: '抗真菌药',value:'antifungal'},
            { text: '抗病毒药',value:'antiviral'},
            { text: '全身性糖皮质激素',value:'glucocorticoid'},
            { text: '吸氧',value:'oxygen'},
            { text: '机械通气',value:'mechanical_ventilation'},
            { text: '有创机械通气',value:'invasive_mechanical_ventilation'},
            { text: '体外膜氧合',value:'ecmo'},
            { text: '静脉免疫球蛋白',value:'ivig'},
            { text: '连续性肾脏替代治疗',value:'continuous_renal_replacement'},
            { text: '入住ICU',value:'icu_admission'},
        ]
      }
      return data
    }
  },
  watch:{
    active(){
      this.fetchData(this.pageSize)
       this.$refs.list && this.$refs.list.setScrollTop(0)
    },
    /**
     * @description 监听路由变化 如果不是从详情过来 那么删除 筛选项
     */
    '$route'(to,form){
      if (form.name != 'AcademicLiteratureDetail' && form.name != 'AcademicLiteratureList'){
        console.log(form.name,'删除缓存')
        this.active = 0
        this.article_type__in = []
        this.case_concluded__in= []
        this.journal_type__in= []
        this.treatmentMethod= []
        this.pageSize = 10
      }
    }
  },
  created() {
    this.createdInit()
  },
  activated(){
    this.createdInit()
  },
  methods:{
    createdInit(){
        document.title = '文献'
        if (this.$route.query.pageSize){
          this.pageSize = this.$route.query.pageSize
        }
        const callback = ()=>{
          this.$nextTick(()=>{
              const target = this.$refs.list.$el
              const Vnode = this.$refs[`simpleCard-${this.$route.query.id}`]
              if (this.$route.query.id && Vnode && target){
                const offsetTop = Vnode[0].$el.offsetTop
                this.$refs.list.setScrollTop(offsetTop)
              }else{
                console.log(this.$route.query.id)
                console.log(target)
                console.log(Vnode)
              }
              target && target.addEventListener('scroll',debounce(()=>{
                this.scrollTop = target.scrollTop
              },100))
            })
        }
        this.fetchData(this.pageSize,callback)
    
    },
    /**
     * @description 下拉刷新
     */
    handleRefresh(){
        this.refresh = true
        const callback = ()=>{
          Toast.success('刷新成功')
          this.refresh = false

        }
        this.fetchData(10,callback)
    },
    handlerScroll(){
      this.fetchData(this.pageSize + 10)
    },
    handleCardClick(item){
      this.$router.push({
        query:{
          ...this.$route.query,
          id:item.id,
          pageSize:this.pageSize
        }
      })
      this.$router.push({
        path:'/academicLiteratureDetail',
        query:{
           ...this.$route.query,
          pageSize:this.pageSize,
          order:item.order,
          id:item.id,
        }
      })
    },
    fetchData(pageSize,callback) {
      if (this.timeOut){
        clearTimeout(this.timeOut)
      }
      
     this.timeOut = setTimeout(()=>{
         Toast.loading({
          message: '加载中...',
          forbidClick: true,
          loadingType: 'spinner'
        });
        let data = {
          page:1,
          article_type__in:this.article_type__in.join(','),// 研究类型
          case_concluded__in:this.case_concluded__in.join(','),
          journal_type__in:this.active === 0 ? this.journal_type__in.join(','): this.active === 1 ? '核心期刊': 'SCI',
          query_condition:{},
          page_size:pageSize,
          order__in:this.$route.query.order__in
        }
        this.treatmentMethod.forEach(obj=>{
          data.query_condition[`${obj}__isnull`] = true
        })
        if (JSON.stringify(data.query_condition) !== '{}'){
          data.query_condition = JSON.stringify(data.query_condition)
        }
        HttpRequest({url:'/academic/journal_studies/',params:data}).then(res=>{
          console.log('请求完毕')
            this.timeOut = null
            this.response = res
            this.pageSize = res.page_size
            this.response.results.map(obj=>{
              obj.tag_list.map(tag=>{
                const length = tag[1] - 1
                tag.push(this.color[length])
                tag.push(this.bgColor[length])
              })
            })
            callback && callback() 
            Toast.clear()
          })
      },100)
    }
  }
}
</script>
<style lang="less" >
.van-dropdown-menu__item{
    width:30%
}
.simple-card{
  padding-bottom:8px !important;
    .content{
        margin-top:0px !important;
        >div{
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
        }
    }
    .footer-top{
        display:flex;
        align-items:center;
        color:#999999;
      
    }
    .footer-tag{
        margin-top:0.12rem;
       
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;

    }
}
.academicLiteratureList{
  width:100%;
  height: 100%;
  .academicLiteratureList-container{
    width:100%;
    height: 100%;
    .academicLiteratureList-tab{
        width:100%;
        height: 100%;
    }
  }
  .drop-down-item-title{
    color: #999999;
    font-size: 14px;
  }
  .drop-down-item-title-active{
    color: #FE7922;
  }
}

</style>